import React, { FC } from "react";
import NcImage from "shared/NcImage/NcImage";
import PostCardMeta from "components/PostCardMeta/PostCardMeta";
import { Link } from "react-router-dom";

export interface Card13Props {
  className?: string;
  post: any;
}

const Card13: FC<Card13Props> = ({ className = "", post }) => {
  const href = post?.slug || "#";
  const hero_image = post?.hero_image || "";
  const date = post?.created_at
    ? new Date(post.created_at).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    })
    : "Unknown Date";
  const title = post?.title || "";
  const desc = post?.description || "";
  return (
    <div className={`nc-Card13 relative flex  justify-between ${className}`} data-nc-id="Card13">
      <div className="flex flex-col h-full py-2 ">
        <h2 className={`nc-card-title block font-semibold text-base`}>
          <Link to={href} className="line-clamp-2" title={title}>
            {title}
          </Link>
        </h2>
        <span className="hidden sm:block my-3 text-neutral-500 dark:text-neutral-400 ">
          <span className="line-clamp-2">  <div
            className="trix-content"
            dangerouslySetInnerHTML={{ __html: desc }}
          /></span>
        </span>
        <span className="mt-4 block sm:hidden text-sm text-neutral-500 ">
          {date}
        </span>
        <div className="hidden sm:block">
          <PostCardMeta meta={{ ...post }} post={post} />
        </div>
      </div>

      <Link
        to={href}
        className={`block relative flex-shrink-0 w-2/5 sm:w-1/3 ml-3 sm:ml-5`}
      >
        <NcImage
          containerClassName=" "
          className="object-cover w-full max-h-[180px] rounded-xl sm:rounded-3xl"
          src={hero_image}
          alt={title}
        />
        {/* <PostTypeFeaturedIcon
          className="absolute bottom-2 left-2"
          // postType={postType}
          wrapSize="w-8 h-8"
          iconSize="w-4 h-4"
        /> */}
      </Link>
    </div>
  );
};

export default Card13;
